import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons';
import { CONTACT_INFO } from '../data/constants';
import Availability from '../components/common/Availability';
import styles from './ContactPage.module.css';

const ContactPage: React.FC = () => {
  return (
    <>
      <div className={styles.contactPage}>
        <div className="container">
          <div className={styles.header}>
            <h1 className={styles.title}>Contact</h1>
          </div>

          <div className={styles.contactMethods}>
            <a
              href={CONTACT_INFO.linkedin.url}
              className={styles.contactCard}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.iconWrapper}>
                <FontAwesomeIcon icon={faLinkedin} className={styles.icon} />
              </div>
              <div>
                <h3 className={styles.cardTitle}>LinkedIn</h3>
                <span className={styles.cardLink}>{CONTACT_INFO.linkedin.displayUrl}</span>
              </div>
            </a>

            <a
              href={`mailto:${CONTACT_INFO.email}`}
              className={styles.contactCard}
            >
              <div className={styles.iconWrapper}>
                <FontAwesomeIcon icon={faEnvelope} className={styles.icon} />
              </div>
              <div>
                <h3 className={styles.cardTitle}>Email</h3>
                <span className={styles.cardLink}>{CONTACT_INFO.email}</span>
              </div>
            </a>

            <a
              href={CONTACT_INFO.github.url}
              className={styles.contactCard}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.iconWrapper}>
                <FontAwesomeIcon icon={faGithub} className={styles.icon} />
              </div>
              <div>
                <h3 className={styles.cardTitle}>GitHub</h3>
                <span className={styles.cardLink}>{CONTACT_INFO.github.displayUrl}</span>
              </div>
            </a>

            <a
              href={CONTACT_INFO.gumroad.url}
              className={styles.contactCard}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.iconWrapper}>
                <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
                  <line x1="3" y1="6" x2="21" y2="6"/>
                  <path d="M16 10a4 4 0 01-8 0"/>
                </svg>
              </div>
              <div>
                <h3 className={styles.cardTitle}>Gumroad : Templates Notion</h3>
                <span className={styles.cardLink}>{CONTACT_INFO.gumroad.displayUrl}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
      <Availability />
    </>
  );
};

export default ContactPage;
